
export {SetupManager, PLAY_ALL_MONITOR, modifyPlayAllMonitor};

import {DataTable} from './datatable.js';
import {
	cap_first,
	e,
	get_cookie,
	hms_to_secs,
	httpPost,
	jersify,
	secs_to_hms,
	set_cookie
} from './utils.js';
import {SetupVideoButton} from './buttons.js';
import {
	CLIP_BACKSTEP,
	EDIT_EVENT_URL,
	EDIT_MATCH_URL,
	CLIP_FORESTEP,
	EDIT_STAT_URL,
	EDIT_TOUCH_STAT_URL,
	UNDO_EDITS_URL,
	UNDO_TOUCH_EDITS_URL,
	VID_ATTACH_URL,
	VID_DETACH_URL,
	Actions,
	get_action_label
} from './config.js';

import {PlayerMgr, TabMgr, state, get_game, hide_columns_for_wr, convertTouchLogEntry} from './index.js';
import {AnchorDot} from './glyphs.js';
import {ytplayerState} from './ytplayer.js';



// http://www.youtube.com/watch?v=lWjQSmjTfZQ
// http://www.youtube.com/watch?v=gpVRleg4twg

// ---------------------------
// SETUP MANAGER
// ---------------------------

var PLAY_ALL_MONITOR = null;

function modifyPlayAllMonitor(value) {
	PLAY_ALL_MONITOR = value;
}

function SetupManager() {

	// ---------------------------
	// Properties
	// ---------------------------

	var LogTable       = new DataTable(e("setup_log_table"), "", true, false, this);

	var attached_msg   = e("attached_msg");
	var unattached_msg = e("unattached_msg");
	var synced_msg     = e("synced_msg");

	var bAddVideo    = SetupVideoButton(70, 20, "+ Video", this);
	var bDelVideo    = SetupVideoButton(70, 20, "- Video", this);
	var bSync        = SetupVideoButton(70, 20, "Sync", this);
	var bUnsync      = SetupVideoButton(70, 20, "Unsync", this);
	var bPlay        = SetupVideoButton(70, 20, "Play", this);
	var bAddStat     = SetupVideoButton(70, 20, "Add <u>S</u>tat", this);
	var bUndoEdits   = SetupVideoButton(70, 20, "Undo Edits", this);
	var bPlayAll     = SetupVideoButton(70, 20, "Play All", this);

	var attached_monitor = null;
	var synced_monitor   = null;

	var LogRecs      = [];
	var Players      = [];

	var SelGame      = null;

	// ---------------------------
	// Styling
	// ---------------------------


	// ---------------------------
	// Inits
	// ---------------------------

	e("setup_video_cmds1").appendChild(bPlayAll);
	e("setup_video_cmds1").appendChild(bPlay);
	e("setup_video_cmds1").appendChild(bAddVideo);
	e("setup_video_cmds1").appendChild(bDelVideo);
	e("setup_video_cmds2").appendChild(bSync);
	e("setup_video_cmds2").appendChild(bUnsync);
	e("setup_video_cmds2").appendChild(bAddStat);
	e("setup_video_cmds2").appendChild(bUndoEdits);

	$("#new_stat_modal").easyModal();
	$("#match_modal").easyModal();
	$("#video_select_modal").easyModal();
	$("#assist_modal").easyModal();

	$(document).keydown(function(el){
		// bind "s" to Add Stat modal
		if (TabMgr.active().id === 'setup_page' && !bAddStat.disabled && $('#new_stat_modal:hidden').length && $('#match_modal:hidden').length && $('#assist_modal:hidden').length && ytplayerState.yt_player && el.keyCode == 83){
			f_open_stat_modal();
			return false;
		}
		// bind return to submit active modal
		if (el.keyCode == 13){
			if ($('#new_stat_modal:visible').length){
				$('#modal_save').click();
				return false;
			} else if ($('#match_modal:visible').length){
				$('#match_modal_save').click();
				return false;
			} else if ($('#video_select_modal:visible').length){
				$('#video_select_modal_save').click();
				return false;
			}
		}
		// bind up/down arrow keys to highlight prev/next stat
		if (TabMgr.active().id === 'setup_page' && $('#new_stat_modal:hidden').length && $('#match_modal:hidden').length && el.keyCode == 38){
			$(LogTable.get_sel_row()).prev().click();
			return false;
		}
		if (TabMgr.active().id === 'setup_page' && $('#new_stat_modal:hidden').length && $('#match_modal:hidden').length && el.keyCode == 40){
			$(LogTable.get_sel_row()).next().click();
			return false;
		}
	});


	// ---------------------------
	// Add heads
	// ---------------------------

	LogTable.add_head("playernum",  "int",    "",               "center",   0);
	LogTable.add_head("jerseynum",  "int",    "No.",            "center",   1);
	LogTable.add_head("playername", "str",    "Player",         "left",     3);
	if (state.touch) {
		LogTable.add_head("action_cat",  "str",    "Category",       "left",   2);
		LogTable.add_head("action",      "str",    "Action",         "left",   3);
	} else {
		LogTable.add_head("action",     "str",    "Action",         "left",   3);
		LogTable.add_head("assistnum",  "assist", "Assist",         "left",   1);
		LogTable.add_head("score",      "score",  "Score",          "center", 1);
	}
	LogTable.add_head("video",      "str",    "Attached Video", "left",     2);
	LogTable.add_head("offset",     "str",    "Offset",         "center",   2);
	LogTable.add_head("vstate",     "glyph",  "Synced",         "center",   1);
	LogTable.add_head("delete",     "del",    "Del",            "center",   1);
	if (state.wr_editor){
		$(LogTable.get_head("vstate")).hide().next().hide();
		$(LogTable.get_head("offset")).hide().next().hide();
		$(LogTable.get_head("video")).hide().next().hide();
	}

	// ---------------------------
	// Functions
	// ---------------------------

	this.get_ytid            = f_get_ytid;

	this.load_game_selector  = f_load_game_selector;
	this.load_log_table      = f_load_log_table;

	this.mark_synced_recs    = f_mark_synced_recs();

	this.show_attached_msg   = f_show_attached_msg;
	this.hide_attached_msg   = f_hide_attached_msg;
	this.show_unattached_msg = f_show_unattached_msg;
	this.hide_unattached_msg = f_hide_unattached_msg;
	this.show_synced_msg     = f_show_synced_msg;
	this.hide_synced_msg     = f_hide_synced_msg;

	this.attach_video_response = f_attach_video_response;
	this.game_selected         = f_game_selected;
	this.row_selected          = f_row_selected;
	this.row_dblclicked        = f_row_dblclicked;
	this.clicked               = f_clicked;


	// ---------------------------
	// Utility Methods
	// ---------------------------

	function f_get_ytid(url) {

		var pattern = /\/watch\?v=[-_a-zA-Z0-9]{11}/g;
		var result  = pattern.exec(url);
		if (result && result[0].length === 1){
			return result.substring(9);
		} else if (result && result[0]){
			return result[0].substring(9);
		}

		pattern = /\/v\/[-_a-zA-Z0-9]{11}/g;
		result  = pattern.exec(url);
		if (result && result[0].length === 1){
			return result.substring(9);
		} else if (result && result[0]){
			return result[0].substring(3);
		}

		pattern = /youtu\.be\/[-_a-zA-Z0-9]{11}/g;
		result  = pattern.exec(url);
		if (result && result[0].length === 1){
			return result.substring(9);
		} else if (result && result[0]){
			return result[0].substring(9);
		}

		return null;
	}

	function f_get_video_by_logix(logix) {
		for (let i = 0; i < state.videos[SelGame].length; i++) {
			if (state.videos[SelGame][i].logix == logix) {
				return state.videos[SelGame][i];
			}
		}

		// No video found
		return null;
	}

	function f_attach_video(uid, gid, logix, vid, offset, f_callback) {
		// Create the upload payload
		var payload = '';
		payload += 'uid='     + uid;
		payload += '&gid='    + gid;
		payload += '&logix='  + logix;
		payload += '&vid='    + vid;
		payload += '&offset=' + offset;

		// Post it
		httpPost(VID_ATTACH_URL, payload, f_callback);
	}

	function f_detach_video(uid, gid, logix, f_callback) {
		// Create the upload payload
		var payload = '';
		payload += 'uid='     + uid;
		payload += '&gid='    + gid;
		payload += '&logix='    + logix;

		// Post it
		httpPost(VID_DETACH_URL, payload, f_callback);
	}

	function f_replace_game_data(game_id, data){
		if (typeof data === "string"){
			data = JSON.parse(data);
		}
		for (var i=0; i < state.games.length; i++) {
			if (state.games[i].id == game_id) {
				state.games[i] = data;
				if (state.touch){
					state.games[i].match_id = state.games[i].matchEventId;
					// Convert log entry format
					var newlog = [];
					var players = [];
					for (var y=0, ylen=state.teams.length; y < ylen; y++) {
						if (state.teams[y].id === state.games[i].teamId) {
							players = state.teams[y].players;
						}
					}
					for (var z=0, zlen=state.games[i].log.length; z < zlen; z++) {
						var newEntry = convertTouchLogEntry(state.games[i].log[z], players);
						newlog.push(newEntry);
					}
					state.games[i].oldlog = state.games[i].log;
					state.games[i].log = newlog;
				}
				break;
			}
		}
	}


	// ---------------------------
	// Loading Methods
	// ---------------------------

	function f_load_game_selector() {

		// Get the selected team
		if (e("selTeam").selectedIndex < 0) {
			return;
		}

		// Get the team id
		var team_id = e("selTeam").value;

		// Init the match ids
		var match_ids = [];

		// Get the matches dict
		var matches = {};

		for (let i=0, ilen=state.matches.length; i < ilen; i++) {

			if (! state.matches[i]) {
				continue;
			}

			if (state.matches[i].team_id == team_id) {
				let match_id = state.matches[i].id;
				matches[match_id] = state.matches[i];
				match_ids.push(match_id);

				if (!matches[match_id]['games']) {
					matches[match_id]['games'] = {};
				}

				for (let j=0, jlen=state.games.length; j < jlen; j++) {

					if (! state.games[j]) {
						continue;
					}

					let game_id = state.games[j].id;

					if (state.games[j].match_id == match_id) {
						matches[match_id].games[game_id] = state.games[j];
					}
				}
			}
		}

		// Sort the match ids in ascending date order
		match_ids.sort( function(a, b) {
			if (
				(new Date(matches[a].start_dt || matches[a].startDate || matches[a].created)) >
				(new Date(matches[b].start_dt || matches[b].startDate || matches[b].created))
			) {
				return 1;
			} else {
				return -1;
			}
		});


		// Clear current options in the selector
		while (e("selGame").options.length > 0) {
			e("selGame").remove(0);
		}

		// Run through the team matches
		for (let i = 0; i < match_ids.length; i++) {

			// Get the match metadata
			let match = matches[match_ids[i]];

			// Get the game ids for the match
			let game_ids = [];
			for (let game_id in match.games) {
				game_ids.push(game_id);
			}

			// Sort the game ids based on ascending game number
			/* jshint -W083 */
			// TODO: fix this JSHint later
			game_ids.sort(function(a, b) {
				if (match.games[a].num > match.games[b].num) {
					return 1;
				} else {
					return -1;
				}
			});
			/* jshint +W083 */

			// Run through the games in the match
			for (let j = 0; j < game_ids.length; j++) {
				// Get the game
				var game   = matches[match_ids[i]].games[game_ids[j]];

				// Create the select option
				var opt       = document.createElement('option');
				opt.value     = game_ids[j];
				opt.innerHTML = new Date(match.start_dt || match.startDate || match.created).toString().substring(0, 15) + " &bull; " + match.opponent.toUpperCase() + " &bull; " + match.venue.toUpperCase() + " &bull; ";
				if (state.touch) {
					opt.innerHTML += game.name;
				} else {
					opt.innerHTML += "Game " + game.num;
				}
				e("selGame").add(opt);
			}
		}

		// Update the games in the sync list when changed
		e("selGame").onchange = function() {
			f_game_selected();
		};

		// Select the game
		if (e("selGame").options.length > 0) {
			// Get the team game cookie
			var tgc = get_cookie("TEAM_GAME");

			// If the cookie exists, pre-select the game
			if (tgc) {
				var payload = JSON.parse(tgc);

				if (payload.team_id) {
					if ((payload.team_id == e("selTeam").value) && (payload.game_id)) {
						e("selGame").value = payload.game_id;
					}
				}
			}

			e("selGame").onchange();
		}
	}

	function f_load_log_table() {
		// Get the game of the currently selected game
		var game = get_game(SelGame);

		// Check the game
		if (! game){
			return;
		}

		// Init the log recs
		LogRecs = [];

		// Init the score
		var score  = {};
		score.us   = 0;
		score.them = 0;

		// Init player roster
		Players = [];

		// Run through the log
		for (let i = 0; i < game.log.length; i++) {
			var rec = game.log[i];

			// Check if a log adjustment
			if (rec[0] == "LogAdjustment") {
				// Go to next loop if not a log entry
				score.us   += rec[3];
				score.them += rec[4];
				continue;
			}

			// Check if a log timeout or substitution
			if (rec[0] == "LogTimeout" || rec[0] == "LogSubstitution") {
				continue;
			}

			// Update the score
			score[rec[9]] += rec[10];

			var log_rec;

			if (rec[0] === "LogEntry" || rec[0] === "LogPartial") {
				var action_category = state.touch ? (game.oldlog[i].action.tags[1] || game.oldlog[i].action.tags[0]) : rec[7];
				log_rec         = {};
				log_rec.logix       = LogRecs.length;
				log_rec.game_id     = game.game_id;
				log_rec.date        = rec[1];
				log_rec.rotation    = rec[2];
				log_rec.serving     = rec[3];
				log_rec.team        = rec[4];
				log_rec.playernum   = rec[5];
				log_rec.jerseynum   = jersify(rec[5]);
				log_rec.playername  = rec[6] ? rec[6] : '< UNKNOWN >';
				log_rec.action_cat  = state.touch ? cap_first(action_category) : rec[7];
				log_rec.action_code = rec[8];
				if (action_category){
					log_rec.action  = state.touch ? get_action_label(action_category, rec[8]) : cap_first(action_category).replace('_', '-') + ": " + get_action_label(action_category, rec[8]);
				} else {
					log_rec.action  = '< UNKNOWN >';
				}
				log_rec.pointto     = cap_first(rec[9]);
				log_rec.points      = rec[10];
				log_rec.server      = rec[11];
				log_rec.setter      = rec[12];
				log_rec.assistnum   = log_rec.team === "us" ? jersify(rec[13]) : null;  // ignore incorrect assist data on Their Player entries
				log_rec.assistname  = log_rec.team === "us" ? rec[14] : null;
				log_rec.score       = { 'us':score.us, 'them':score.them };

				log_rec.video       = "";
				log_rec.offset      = 0;
				log_rec.vid         = null;
				log_rec.vstart      = -1;
				log_rec.vend        = -1;
				log_rec.vstate      = AnchorDot();

				if (rec[4] == 'them') {
					log_rec.playernum  = '-';
					log_rec.playername = 'Opponent';
				}
				if (log_rec.action_cat === 'Meta'){
					log_rec.action_cat = '';
				}
			}

			// Add to the list of log recs
			LogRecs.push(log_rec);
		}

		// Load the log entires
		LogTable.load_data(LogRecs, true, true);

		// Mark the synced points
		f_mark_synced_recs();

		// Select the first row
		if (LogRecs.length > 0) {
			f_row_selected(0);
		}

		// Get roster for the current game
		for (let i=0; i < state.teams.length; i++){
			var team = state.teams[i];
			if (
				(game.team_id && game.team_id.toString() === team.id.toString())
				|| (game.teamId && (game.teamId.toString() === team.id.toString()))
			){
				Players = team.players;
			}
		}

		f_enable_editable_cells();
		f_enable_delete_row();
		f_enable_edit_match();
		if (state.wr_editor){
			hide_columns_for_wr();
		}
	}

	// ---------------------------
	// Youtube Methods
	// ---------------------------

	function f_yt_initial_list() {

		var results = {};

		if (state.yt_auth) {
			$.ajax({
				type: "GET",
				url: "/vidix/youtube/list",
				async: false,
				dataType : "json",
				success: function(data){
					results = data;
				},
				fail: function(){
					alert("Unable to get YouTube videos. Please try again later.");
				}
			});
		}

		return results;
	}

	function f_yt_more_list(page) {

		var results = {};

		if (state.yt_auth) {
			$.ajax({
				type: "GET",
				url: "/vidix/youtube/list?page=" + page,
				async: false,
				dataType : "json",
				success: function(data){
					results = data;
				},
				fail: function(){
					alert("Unable to get YouTube videos. Please try again later.");
				}
			});
		}

		return results;
	}

	function f_yt_add_video_rows(table, videos) {

		var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };

		$.each(videos, function(){
			var date = new Date(this.timestamp);
			var item = '<tr class="yt_item" style="background-color: rgb(255, 255, 255)" data-id="' + this.id + '">' +
				'<td>' + '<img src=' + this.thumb + ' /></td>' +
				'<td>' + this.title + '<br />' +
				'<span>' + date.toLocaleString('en-US', options) + '</span><br />' +
				'<button type="button" class="yt-preview" data-id="' + this.id + '">Preview Video</button>' +
				'</td>' +
				'</tr>';

			table.append(item);
		});
	}

	function f_yt_handle_preview(item) {

		if (item.text() === 'Preview Video') {
			var width = item.parent().width();
			var iframe = '<iframe width="' + (width - 10) +'" height="' + (width*3/4) + '" src="https://www.youtube.com/embed/' + item.data("id") + '"></iframe>';
			item.text("Close Preview");
			item.parent().append(iframe);

		} else {
			item.parent().children('iframe').remove();
			item.text("Preview Video");
		}
	}

	// ---------------------------
	// Stat Editor Methods
	// ---------------------------

	function f_codify_category(string) {
		return string.toLowerCase().replace('-', '_');
	}

	function f_enable_editable_cells() {

		var pencil = '<span class="floatwrap"><img src="/static/img/site/pencil.png" class="edit_icon"/></span>';

		$('.playername_cell').not(':empty').append(pencil).editable(
			function(value){
				if (value === '_'){
					return f_load_log_table;
				}
				var player_data = JSON.stringify([value, f_get_player_name_from_num(value)]);
				f_post_log_edit(this, player_data, 'player');
				$(this).css('background-color', 'white').css('text-align', 'center');
				return '<img class="spinner" src="/static/img/web_reports/spinner.gif">';
			},
			{
				type: 'select',
				data: function(value){
					return f_get_dropdown_players(value);
				},
				onchange: 'submit',
			});

		$('.action_cell').not('.noedit').append(pencil).editable(
			function(value){
				if (value === '_'){
					return f_load_log_table;
				} else if (value.indexOf('|') > -1){
					value = value.split('|').slice(-1)[0];
				}
				var action_data = JSON.stringify([f_get_category_from_action(this), value]);
				f_post_log_edit(this, action_data, 'action');
				$(this).css('background-color', 'white').css('text-align', 'center');
				return '<img class="spinner" src="/static/img/web_reports/spinner.gif">';
			},
			{
				type: 'select',
				data: function(value){
					return f_get_dropdown_actions(value);
				},
				onchange: 'submit',
			});

		$('.assistnum_cell').not('.noassist').append(pencil).off('click').click(function(){
			f_open_assist_modal(this);
		});

		$('.offset_cell').not(':empty').append(pencil).editable(
			function(value){
				var offset = hms_to_secs($(this).find('option[value="' + value + '"]').text()),
				    old_timestamp = $(this).parent().attr('data_timestamp'),
					video_logix = f_get_video_at_timestamp(old_timestamp).logix,
					edited_logix = f_get_log_entry_at_timestamp(old_timestamp).logix,
				    video;

				value = JSON.stringify([value, offset]);
				if (video_logix === edited_logix){
					// only pass video if edited stat is a sync point
					video = video_logix;
				}
				f_post_log_edit(this, value, 'offset', video);
				$(this).css('background-color', 'white');
				return '<img class="spinner" src="/static/img/web_reports/spinner.gif">';
			},
			{
				type: 'select',
				data: function(){
					return f_get_dropdown_offsets(this);
				},
				onchange: 'submit'
			});
	}

	function f_enable_delete_row() {
		$('.can_delete').click(function(){
			var uid = state.solouid,
			    game = e("selGame").value,
			    entry_row = $(this).parent(),
			    entryix = entry_row.index(),
			    timestamp = entry_row.attr('data_timestamp'),
			    ts_entry = f_get_log_entry_at_timestamp(timestamp),
			    video = f_get_video_at_timestamp(timestamp);

			var pkg = {
				uid: uid,
				game: game,
				timestamp: timestamp,
				edited_data: 'delete',
				value: ts_entry.logix
			};

			if (video){
				pkg.video = video.logix;
			}

			entry_row[0].select(false);
			if (confirm("Delete this stat?")) {
				$(this).css('background-color', 'white').html('<img class="spinner" src="/static/img/web_reports/spinner.gif">');
				$.ajax({
					type: 'POST',
					url: state.touch ? EDIT_TOUCH_STAT_URL : EDIT_STAT_URL,
					data: pkg,
					dataType : "json",
					context: this
				}).done(function(data){
					f_replace_game_data(SelGame, data.app_data);
					var vid_data = data.vid_data;
					if (typeof vid_data === "string"){
						vid_data = JSON.parse(vid_data);
					}
					state.videos[SelGame] = vid_data;
					f_load_log_table();
					$($('.data_table_row:visible')[entryix]).click();
				}).fail(function(){
					$('.spinner').parent().css('background-color', 'inherit').html('X');
					alert('Unable to save request. Please try again later.');
				});
			}
		});
	}

	function f_enable_edit_match() {

		$('#edit_match_link').off('click').click(function(){
			var sel_game = parseInt(e('selGame').value),
			    edited_game,
			    edited_match,
			    match_date,
			    $modal = $('#match_modal'),
			    $name_input = $('#match_modal_name'),
			    $venue_input = $('#match_modal_venue'),
			    $month_input = $('#match_month'),
			    $day_input = $('#match_day'),
			    $year_input = $('#match_year'),
			    $error_msg = $('#match_modal .modal_msg'),
				$cancel_btn = $('#match_modal_cancel'),
				$save_btn = $('#match_modal_save'),
				$spinner = $('#match_modal .modal_spinner'),
				$date_inputs = $('.modal_date');

			if (ytplayerState.yt_player && ytplayerState.yt_player.pauseVideo){
				ytplayerState.yt_player.pauseVideo();
			}
			$modal.trigger('openModal');
			$error_msg.hide();
			$save_btn.attr('disabled', false);
			$spinner.hide();

			// get game/match data
			var i;
			for (i=0; i < state.games.length; i++){
				if (state.games[i].id === sel_game){
					edited_game = state.games[i];
					break;
				}
			}
			for (i=0; i < state.matches.length; i++){
				if (state.matches[i].id === parseInt(edited_game.match_id)){
					edited_match = state.matches[i];
					break;
				}
			}

			// initialize name
			$name_input.val(edited_match.opponent);

			// initialize venue
			$venue_input.val(edited_match.venue);

			// initialize date
			match_date = new Date(edited_match.start_dt || edited_match.startDate || edited_match.created).toISOString();
			$month_input.val(match_date.substring(5, 7));
			$day_input.val(match_date.substring(8, 10));
			$year_input.val(match_date.substring(0, 4));

			// set up interactions
			$date_inputs.off('focus').focus(function(){
				$(this).select();
			}).off('keyup').keyup(function(){
				// Only allow integer input
				if (this.value != this.value.replace(/[^0-9]/g, '')) {
					this.value = this.value.replace(/[^0-9]/g, '');
				}
				$error_msg.hide();
			});
			$cancel_btn.off('click').click(function(){
				$modal.trigger('closeModal');
			});
			$save_btn.off('click').click(function(){
				var valid_date = true,
				    edited_date,
				    match_games = [],
				    pkg;

				// check for name and venue text
				if (!$name_input.val().length || !$venue_input.val().length){
					alert('Please enter a value for all fields.');
					return false;
				}

				// validate date
				$date_inputs.each(function(){
					if (isNaN(parseInt(this.value))){
						valid_date = false;
					}
				});
				if (valid_date){
					if (parseInt($month_input.val()) < 1 || parseInt($month_input.val()) > 12){
						valid_date = false;
					}
					if (parseInt($day_input.val()) < 1 || parseInt($day_input.val()) > 31){
						valid_date = false;
					}
					if (parseInt($year_input.val()) < 1970){
						valid_date = false;
					}
				}
				if (!valid_date){
					$error_msg.show();
					return false;
				}
				edited_date = new Date($month_input.val() + "-" + $day_input.val() + "-" + $year_input.val()).toDateString();

				// get all games associated with the match so their dates can be changed
				for (i=0; i < state.games.length; i++){
					if (state.games[i].match_id === edited_game.match_id){
						match_games.push(state.games[i].id);
					}
				}

				pkg = {
					uid: state.solouid,
					match: edited_match.id,
					match_games: JSON.stringify(match_games),
					name: $name_input.val(),
					venue: $venue_input.val(),
					date: edited_date + ' ' + new Date(edited_match.start_dt || edited_match.startDate || edited_match.created).toTimeString()
				};
				$save_btn.attr('disabled', true);
				$spinner.show();
				// refresh spinner src to ensure animation plays
				$spinner.attr('src', $spinner.attr('src'));

				$.ajax({
					type: 'POST',
					url: state.touch ? EDIT_EVENT_URL : EDIT_MATCH_URL,
					data: pkg,
					context: this
				}).done(function() {
					var tab_regex = /&tab=([^&]*)/g;  // removes any existing tab value from query string
					location.replace( location.href.replace(tab_regex, "") + "&tab=setup" );
				}).fail(function() {
					$spinner.hide();
					alert('Unable to save request. Please try again later.');
					$save_btn.attr('disabled', false);
				});

			});
		});
	}

	function f_post_log_edit(that, value, edited_data, video){
		var uid = state.solouid,
			game = e("selGame").value,
			entry_row = $(that).parent(),
			timestamp = entry_row.attr('data_timestamp'),
			pkg = {
				uid: uid,
				game: game,
				timestamp: timestamp,
				edited_data: edited_data,
				value: value
			};

		if (video !== undefined){
			pkg.video = video;
		}

		$.ajax({
			type: 'POST',
			url: state.touch ? EDIT_TOUCH_STAT_URL : EDIT_STAT_URL,
			data: pkg,
			dataType : "json",
			context: this
		}).done(function(data){
			f_replace_game_data(SelGame, data.app_data);
			var vid_data = data.vid_data;
			if (typeof vid_data === "string"){
				vid_data = JSON.parse(vid_data);
			}
			state.videos[SelGame] = vid_data;
			f_load_log_table();
			if (edited_data === "offset"){
				$('.data_table_row[data_timestamp="' + JSON.parse(value)[0] + '"]').click();
			} else {
				$('.data_table_row[data_timestamp="' + timestamp + '"]').click();
			}
		}).fail(function(){
			alert('Unable to save request. Please try again later.');
			f_load_log_table();
		});
	}

	function f_get_player_name_from_num(num) {

		if (num === 'noassist'){
			return null;
		}
		for (var i=0; i < Players.length; i++) {
			if (num.toString() === Players[i].num){
				return Players[i].name;
			}
		}
	}

	function f_get_dropdown_players(value, assist) {

		var players_select = {},
		    selected_value,
		    selected_key;

		if (value) {
			selected_value = value.replace(/ *<[^)]*> */g, "");  //remove html img element
			if (assist) {
				selected_value = selected_value.replace(/^[\d]*-/g, "");  //remove player num
			}
		}

		if (assist){
			players_select['noassist'] = "(No Assist)";
		}
		for (var i=0; i < Players.length; i++) {
			players_select[Players[i].num] = (Players[i].jersey || Players[i].num) + "-" + Players[i].name;
		}
		if (!state.touch && !assist){
			players_select['opp'] = 'Opponent';
		}

		if (selected_value) {
			for (var j=0; j < Players.length; j++) {
				players_select[Players[j].num] = (Players[j].jersey || Players[j].num) + "-" + Players[j].name;
			}
			for (var key in players_select) {
				if (players_select[key].replace(/^[\d]*-/g, "") === selected_value){  //remove player num
					selected_key = key;
					break;
				}
			}
			players_select['selected'] = selected_key;
		}

		if (value === '< UNKNOWN >'){
			// start on blank entry
			players_select = Object.assign({'_': '< UNKNOWN >'}, players_select);
			players_select['selected'] = '_';
		}

		return JSON.stringify(players_select);
	}

	function f_get_dropdown_actions(value) {

		var action_select = {},
			i,
			selected_key,
		    selected_category,
		    selected_action;

		if (value === 'all_in_rally'){
			for (i=0; i < Actions['in_rally'].length; i++){
				action_select[Actions['in_rally'][i][0]] = "In-rally: " + Actions['in_rally'][i][1];
			}
			return JSON.stringify(action_select);
		}

		if (value === '< UNKNOWN >'){
			// return all actions
			let categories = ['in_rally', 'earned', 'errors', 'faults'];
			for (let cat=0; cat < categories.length; cat++){
				for (i=0; i < Actions[categories[cat]].length; i++){

					// The keys for this are normally the action code, but we need to include all categories here,
					// so including category in the string
					// (only for dropdown purposes; the category + '|' is stripped out when saved)
					let key = categories[cat] + '|' + Actions[categories[cat]][i][0];

					action_select[key] = categories[cat].substr(0, 1).toUpperCase() + categories[cat].substr(1).replace('_', '-')
						+ ": " + Actions[categories[cat]][i][1];
				}
			}
			// sort by keys
			Object.keys(action_select).sort().reduce((r, k) => Object.assign(r, { [k]: action_select[k] }), {});
			// start on blank entry
			action_select = Object.assign({'_': '< UNKNOWN >'}, action_select);
			action_select['selected'] = '_';
			return JSON.stringify(action_select);
		}

		value = value.replace(/ *<[^)]*> */g, "");  //remove html img element
		if (state.touch){
			for (var category in Actions){
				if (category === 'earned' || category === 'in_rally' || category === 'errors'){
					continue;
				}
				for (i=0; i < Actions[category].length; i++){
					if (Actions[category][i][1] === value){
						selected_category = category;
						break;
					}
				}
				if (selected_category){
					break;
				}
			}
			selected_action = value;
		} else {
			selected_category = f_codify_category(value.split(': ')[0]);
			selected_action = value.split(': ')[1];
		}

		// get action code from string
		if (selected_category){
			for (i=0; (i < Actions[selected_category].length); i++){
				if (selected_action === Actions[selected_category][i][1]){
					selected_key = Actions[selected_category][i][0];
					break;
				}
			}
		}

		// populate dropdown according to category rules:
		// earned -> earned
		// errors OR faults -> errors+faults
		// in_rally -> same type only (serve; receive+misc; fbpass+misc)
		// Touch shows all actions
		if (selected_category === 'earned'){
			for (i=0; i < Actions['earned'].length; i++){
				action_select[Actions['earned'][i][0]] = "Earned: " + Actions['earned'][i][1];
			}
		}
		if ((selected_category === 'errors' || selected_category === 'faults') && !state.touch){
			for (i=0; i < Actions['errors'].length; i++){
				action_select[Actions['errors'][i][0]] = "Errors: " + Actions['errors'][i][1];
			}
			for (i=0; i < Actions['faults'].length; i++){
				action_select[Actions['faults'][i][0]] = "Faults: " + Actions['faults'][i][1];
			}
		}
		if (selected_category === 'in_rally'){
			// can't figure out an elegant way to do this with loops so it's hardcoded for now
			// may need to be redone to account for serving state
			if (selected_key === '1srv' ||
				selected_key === '2srv' ||
				selected_key === '3srv'
			){
				action_select = { "1srv": "In-rally: 1-Serve", "2srv": "In-rally: 2-Serve", "3srv": "In-rally: 3-Serve" };
			}
			if (selected_key === '0pass' ||
				selected_key === '1pass' ||
				selected_key === '2pass' ||
				selected_key === '3pass'
			){
				action_select = { "0pass": "In-rally: Over Pass in Play", "1pass": "In-rally: 1-Receive", "2pass": "In-rally: 2-Receive", "3pass": "In-rally: 3-Receive",
							      "blksip": "In-rally: Block Still In Play", "dgatt": "In-rally: Dig", "htatt": "In-rally: Hit Still In Play" };
			}
			if (selected_key === '0fbp' ||
				selected_key === '1fbp' ||
				selected_key === '2fbp' ||
				selected_key === '3fbp'
			){
				action_select = { "0fbp": "In-rally: FB Over Pass in Play", "1fbp": "In-rally: 1-FB Pass", "2fbp": "In-rally: 2-FB Pass", "3fbp": "In-rally: 3-FB Pass",
							      "blksip": "In-rally: Block Still In Play", "dgatt": "In-rally: Dig", "htatt": "In-rally: Hit Still In Play", "fbrip": "In-rally: FB Return In Play" };
			}
			if (selected_key === 'blksip' ||
				selected_key === 'dgatt' ||
				selected_key === 'htatt' ||
				selected_key === 'fbrip'
			){
				action_select = { "0pass": "In-rally: Over Pass in Play", "1pass": "In-rally: 1-Receive", "2pass": "In-rally: 2-Receive", "3pass": "In-rally: 3-Receive",
								  "0fbp": "In-rally: FB Over Pass in Play", "1fbp": "In-rally: 1-FB Pass", "2fbp": "In-rally: 2-FB Pass", "3fbp": "In-rally: 3-FB Pass",
							      "blksip": "In-rally: Block Still In Play", "dgatt": "In-rally: Dig", "htatt": "In-rally: Hit Still In Play", "fbrip": "In-rally: FB Return In Play" };
			}
		}
		if (state.touch && selected_category !== 'meta'){
			for (var cat in Actions){
				if (cat === 'earned' || cat === 'in_rally' || cat === 'errors' || cat === 'meta'){
					continue;
				}
				for (i=0; i < Actions[cat].length; i++){
					action_select[Actions[cat][i][0]] = cat.charAt(0).toUpperCase() + cat.slice(1) + ": " + Actions[cat][i][1];
				}
			}
		}

		// get selected action
		for (var key in action_select) {
			if (action_select[key] === value){
				selected_key = key;
				break;
			}
		}
		action_select['selected'] = selected_key;

		return JSON.stringify(action_select);
	}

	function f_get_dropdown_offsets(cell) {

		var $this_row = $(cell).parent(),
			this_stat,
		    prev_stat,
		    next_stat,
		    prev_diff,
		    next_diff,
		    offset = 0,
		    offset_select = {};

		// find previous and next stats
		for (let i=0; i < LogRecs.length; i++){
			if ($this_row.attr('data_timestamp') === LogRecs[i].date){
				this_stat = LogRecs[i];
				prev_stat = LogRecs[i - 1];
				next_stat = LogRecs[i + 1];
				break;
			}
		}
		var this_time = Date.parse(this_stat.date);

		// check for first and last stats and sync points
		if (prev_stat){
			prev_diff = Math.min(((this_time - Date.parse(prev_stat.date)) / 1000), 31, (this_stat.offset+1));
		} else {
			prev_diff = this_stat.offset + 1;
		}
		if (next_stat){
			next_diff = Math.min(((Date.parse(next_stat.date) - this_time) / 1000), 31);
		} else {
			next_diff = offset + 11;
		}

		// get offset range
		for (let i = prev_diff-1; i > 0; i--){
			offset_select[new Date(this_time - (i*1000)).toString()] = secs_to_hms(this_stat.offset - i);
		}
		for (let i = 0; i < next_diff; i++){
			offset_select[new Date(this_time + (i*1000)).toString()] = secs_to_hms(this_stat.offset + i);
		}
		offset_select['selected'] = this_stat.date;

		return offset_select;
	}

	function f_open_assist_modal(cell){
		var players        = JSON.parse(f_get_dropdown_players($(cell).attr('title'), true)),
			timestamp      = $(cell).parent().attr('data_timestamp'),
			$modal         = $('#assist_modal'),
			$player_select = $('#modal_assist'),
			$error_msg     = $('#assist_modal .modal_msg'),
			$cancel_btn    = $('#assist_modal_cancel'),
			$save_btn      = $('#assist_modal_save'),
			$spinner       = $('#assist_modal .modal_spinner');

		if (ytplayerState.yt_player && ytplayerState.yt_player.pauseVideo){
			ytplayerState.yt_player.pauseVideo();
		}
		$modal.trigger('openModal');
		$error_msg.hide();
		$save_btn.attr('disabled', false);
		$spinner.hide();

		// initialize player select
		$player_select.empty();
		$.each(players, function(id, player){
			if (id !== 'selected'){
				$player_select.append($('<option/>').attr('value', id).text(player));
			}
		});
		$player_select.val(players.selected || 'noassist').change();
		$player_select.focus();

		// set up interactions
		$cancel_btn.off('click').click(function(){
			$modal.trigger('closeModal');
		});
		$save_btn.off('click').click(function(){
			var pkg = {
				uid: state.solouid,
				game: e('selGame').value,
				timestamp: timestamp,
				edited_data: 'assist',
				value: JSON.stringify({
					player: [$player_select.val(), f_get_player_name_from_num($player_select.val())],
				})
			};
			$save_btn.attr('disabled', true);
			$spinner.show();
			// refresh spinner src to ensure animation plays
			$spinner.attr('src', $spinner.attr('src'));

			$.ajax({
				type: 'POST',
				url: state.touch ? EDIT_TOUCH_STAT_URL : EDIT_STAT_URL,
				data: pkg,
				dataType: "json",
				context: this
			}).done(function(data){
				f_replace_game_data(SelGame, data.app_data);
				var vid_data = data.vid_data;
				if (typeof vid_data === "string"){
					vid_data = JSON.parse(vid_data);
				}
				state.videos[SelGame] = vid_data;
				f_load_log_table();
				$modal.trigger('closeModal');
			}).fail(function(){
				$spinner.hide();
				alert('Unable to save request. Please try again later.');
				$save_btn.attr('disabled', false);
			});
		});
	}

	function f_open_stat_modal(){
		var players        = JSON.parse(f_get_dropdown_players()),
			actions        = state.touch ? JSON.parse(f_get_dropdown_actions('')) : JSON.parse(f_get_dropdown_actions('all_in_rally')),
			videos         = state.videos[SelGame],
			sel_row        = LogTable.get_sel_row(),
			time_array     = ["0", "00"],
			$modal         = $('#new_stat_modal'),
			$player_select = $('#modal_players'),
			$action_select = $('#modal_actions'),
			$video_select  = $('#modal_videos'),
			$time_inputs   = $('.modal_time'),
			$hour_input    = $('#modal_hour'),
			$min_input     = $('#modal_min'),
			$sec_input     = $('#modal_sec'),
			$error_msg     = $('#new_stat_modal .modal_msg'),
			$cancel_btn    = $('#modal_cancel'),
			$save_btn      = $('#modal_save'),
			$spinner       = $('#new_stat_modal .modal_spinner'),
			use_row_offset = true,
			latest_prior_sync;

		if (ytplayerState.yt_player && ytplayerState.yt_player.pauseVideo){
			ytplayerState.yt_player.pauseVideo();
		}
		$modal.trigger('openModal');
		$error_msg.hide();
		$save_btn.attr('disabled', false);
		$spinner.hide();

		// initialize player select
		$player_select.empty();
		$.each(players, function(id, player){
			$player_select.append($('<option/>').attr('value', id).text(player));
		});
		$player_select.focus();

		// initialize action select
		$action_select.empty();
		$.each(actions, function(id, action){
			$action_select.append($('<option/>').attr('value', id).text(action));
		});

		// initialize video select
		$video_select.empty();
		for (var v in videos){
			$video_select.prepend($('<option/>')
				.attr('value', videos[v].logix)
				.attr('data-vid', videos[v].vid)
				.attr('data-offset', videos[v].offset)
				.text(videos[v].title + " [" + secs_to_hms(videos[v].offset) + "]")
			);
		}

		// Use the current video time if:
		// - the video time is between the selected row's offset and the next row's offset
		//
		// Otherwise:
		// - if the difference between the selected row and the next row is < 6s,
		//   use (this row's time + next row's time) / 2
		//
		// - if the difference between the selected row and the next row is >= 6s,
		//   or there is no next row, use the selected row's offset + 3s
		if ($(sel_row).next().length &&
			$(sel_row).next()[0].dataobj.offset > sel_row.dataobj.offset &&
			ytplayerState.yt_player &&
			ytplayerState.yt_player.getCurrentTime() > sel_row.dataobj.offset &&
			ytplayerState.yt_player.getCurrentTime() < $(sel_row).next()[0].dataobj.offset
		) {
			time_array = secs_to_hms(Math.floor(ytplayerState.yt_player.getCurrentTime())).split(':');
			use_row_offset = false;
		} else if (
			$(sel_row).next().length &&
			$(sel_row).next()[0].dataobj.offset > sel_row.dataobj.offset &&
			$(sel_row).next()[0].dataobj.offset - sel_row.dataobj.offset <= 6
		){
			time_array = secs_to_hms(Math.floor((sel_row.dataobj.offset + $(sel_row).next()[0].dataobj.offset) / 2)).split(':');
		} else {
			time_array = secs_to_hms(LogTable.get_sel_row().dataobj.offset + 3).split(':');
		}
		if (time_array.length === 3){
			$hour_input.val(time_array[0]);
			$min_input.val(time_array[1]);
			$sec_input.val(time_array[2]);
		} else {
			$hour_input.val(0);
			$min_input.val(time_array[0]);
			$sec_input.val(time_array[1]);
		}

		// set default selected video
		$video_select.find('option').each(function(){
			var $this = $(this);
			if (use_row_offset === true){
				if ($this.attr('data-vid') === sel_row.dataobj.vid && sel_row.dataobj.offset >= parseInt($this.attr('data-offset'))){
					latest_prior_sync = $this.val();
				}
			} else {
				if ($this.attr('data-vid') === sel_row.dataobj.vid && ytplayerState.yt_player.getCurrentTime() >= parseInt($this.attr('data-offset'))){
					latest_prior_sync = $this.val();
				}
			}
		});
		$video_select.find('[value="' + latest_prior_sync + '"]').attr('selected', 'selected');

		// set up interactions
		$time_inputs.off('focus').focus(function(){
			$(this).select();
		}).off('blur').blur(function(){
			if (this.value === ''){
				$(this).val(0);
			}
		}).off('keyup').keyup(function(){
			// Only allow integer input
			if (this.value != this.value.replace(/[^0-9]/g, '')) {
				this.value = this.value.replace(/[^0-9]/g, '');
			}
			$error_msg.hide();
		});
		$cancel_btn.off('click').click(function(){
			$modal.trigger('closeModal');
		});
		$save_btn.off('click').click(function(){
			var valid_time = true,
			    timestamp,
			    pkg;

			// validate time
			$time_inputs.each(function(){
				if (isNaN(parseInt(this.value)) || parseInt(this.value) > 59){
					valid_time = false;
				}
			});
			if (!valid_time){
				$error_msg.show();
				return false;
			}
			timestamp = f_convert_modal_timestamp();
			if (!timestamp){
				$error_msg.show();
				alert('Unable to save request. Please try again later.');
				return false;
			}

			pkg = {
				uid: state.solouid,
				game: e('selGame').value,
				timestamp: timestamp,
				edited_data: 'new',
				value: JSON.stringify({
					player: [$player_select.val(), f_get_player_name_from_num($player_select.val())],
					action: [f_get_category_from_action($action_select), $action_select.val()]
				}),
				video: $video_select.val()
			};
			$save_btn.attr('disabled', true);
			$spinner.show();
			// refresh spinner src to ensure animation plays
			$spinner.attr('src', $spinner.attr('src'));

			$.ajax({
				type: 'POST',
				url: state.touch ? EDIT_TOUCH_STAT_URL : EDIT_STAT_URL,
				data: pkg,
				dataType: "json",
				context: this
			}).done(function(data){
				f_replace_game_data(SelGame, data.app_data);
				var vid_data = data.vid_data;
				if (typeof vid_data === "string"){
					vid_data = JSON.parse(vid_data);
				}
				state.videos[SelGame] = vid_data;
				f_load_log_table();
				$modal.trigger('closeModal');
				$('.data_table_row[data_timestamp="' + pkg.timestamp + '"]').click();
			}).fail(function(){
				$spinner.hide();
				alert('Unable to save request. Please try again later.');
				$save_btn.attr('disabled', false);
			});
		});
	}

	function f_convert_modal_timestamp(){
		var offset = ((parseInt($('#modal_hour').val()) * 3600) + (parseInt($('#modal_min').val()) * 60) + parseInt($('#modal_sec').val())) * 1000,
			log = LogRecs[0],
			sync_time,
			new_stat_time,
			timestamp;

		// get log entry that marks video sync point
		for (let i=0; i < LogRecs.length; i++){
			if (LogRecs[i].logix === parseInt($('#modal_videos').val())){
				log = LogRecs[i];
				break;
			}
		}

		sync_time = Date.parse(log.date) - (log.offset * 1000);
		new_stat_time = sync_time + offset;

		// check for conflict with existing timestamp
		for (let i=0; i < LogRecs.length; i++){
			if (Date.parse(LogRecs[i].date) === new_stat_time){
				// conflict found; add 1 sec to new stat time until conflict is resolved
				new_stat_time = new_stat_time + 1000;
			}
		}

		timestamp = new Date(new_stat_time).toString();
		return timestamp;
	}

	function f_get_log_entry_at_timestamp(timestamp){
		for (let i=0; i < LogRecs.length; i++){
			if (Date.parse(timestamp) === Date.parse(LogRecs[i].date)){
				return LogRecs[i];
			}
		}
	}

	function f_get_video_at_timestamp(timestamp){
		// if stat at given timestamp is synced to a video, returns the synced video
		var vids = [],
		    this_stat = f_get_log_entry_at_timestamp(timestamp);

		if (!this_stat || !state.videos[SelGame]){
			return;
		}

		// get list of videos sorted numerically by logix
		for (let i=0; i < state.videos[SelGame].length; i++){
			vids.push(state.videos[SelGame][i]);
		}
		vids.sort(function(a, b){ return a - b; });

		// return video that the edited stat is synced to
		for (let i=0; i < vids.length; i++){
			if (this_stat.logix >= vids[i].logix){
				return vids[i];
			}
		}
	}

	function f_get_category_from_action(that) {
		return $(that).find('option:selected').text().split(':')[0].toLowerCase().replace('-', '_');
	}


	// ---------------------------
	// Update Methods
	// ---------------------------

	function f_mark_synced_recs() {

		if (! SelGame) {
			return;
		}

		// Get the video records
		var videos = state.videos[SelGame] || [];

		// Sort in reverse logix order
		videos.sort( function(a, b) { return (b.logix > a.logix) ? 1 : -1; } );

		// Init the stop log index
		var stopix = LogRecs.length;

		// Clear all dots
		for (let j = 0; j < stopix; j++) {
			LogRecs[j].ui_elem.update_cell(LogTable.get_head_ix("video"), "");
			LogRecs[j].ui_elem.update_cell(LogTable.get_head_ix("offset"), "");
			LogRecs[j].ui_elem.get_cell(LogTable.get_head_ix("vstate")).firstChild.empty();
		}

		// Run through the videos
		for (let i = 0; i < videos.length; i++) {

			// Make sure the offset is an integer
			videos[i].offset = parseInt(videos[i].offset);

			// Check if the video has been synced
			if ((videos[i].logix < 0) || (videos[i].offset < 0)) {
				continue;
			}

			// Get the starting log index
			var startix = videos[i].logix;

			// Mark the anchor
			LogRecs[startix].ui_elem.get_cell(LogTable.get_head_ix("vstate")).firstChild.anchor();

			// Insert the video title
			LogRecs[startix].ui_elem.update_cell(LogTable.get_head_ix("video"), videos[i].title);

			// Insert the offset
			LogRecs[startix].ui_elem.update_cell(LogTable.get_head_ix("offset"), secs_to_hms(videos[i].offset));

			// Update the rest of the metadata
			LogRecs[startix].vid     = videos[i].vid;
			LogRecs[startix].offset  = Math.max(0, videos[i].offset);
			LogRecs[startix].vstart  = Math.max(0, videos[i].offset - CLIP_BACKSTEP);
			LogRecs[startix].vend    = videos[i].offset + CLIP_FORESTEP;

			// Run through the LogRecs
			for (let j=startix + 1; j < stopix; j++) {
				// Get the diff in seconds between this log point and the synced logix point
				var dsecs = Math.floor((Date.parse(LogRecs[j].date) - Date.parse(LogRecs[startix].date)) / 1000);

				// Insert the video title
				LogRecs[j].ui_elem.update_cell(LogTable.get_head_ix("video"), videos[i].title);

				// Insert the offset
				LogRecs[j].ui_elem.update_cell(LogTable.get_head_ix("offset"), secs_to_hms(videos[i].offset + dsecs));

				LogRecs[j].vid     = videos[i].vid;
				LogRecs[j].offset  = videos[i].offset + dsecs;
				LogRecs[j].vstart  = Math.max(0, videos[i].offset + dsecs - CLIP_BACKSTEP);
				LogRecs[j].vend    = videos[i].offset + dsecs + CLIP_FORESTEP;

				// Update the video dot for the log record
				if (videos[i].offset + dsecs <= videos[i].secs) {
					LogRecs[j].ui_elem.get_cell(LogTable.get_head_ix("vstate")).firstChild.relative();
				} else {
					LogRecs[j].ui_elem.get_cell(LogTable.get_head_ix("vstate")).firstChild.beyond();
				}
			}

			// Update the stop index
			stopix = videos[i].logix;
		}

	}


	// ---------------------------
	// Event Methods
	// ---------------------------

	function f_game_selected() {
		SelGame = e("selGame").value;
		f_load_log_table();

		// Save the team game cookie
		var payload = {};
		payload.team_id = e("selTeam").value;
		payload.game_id = e("selGame").value;
		set_cookie("TEAM_GAME", JSON.stringify(payload));
	}

	function f_row_selected() {
		// Get sync state of log entry
		var vstate = LogRecs[LogTable.get_sel_row().dataobj.logix].ui_elem.get_cell(LogTable.get_head_ix("vstate")).firstChild.state;

		// Disable buttons
		if (vstate == AnchorDot.STATE_EMPTY) {
			bAddVideo.enable();
			bDelVideo.disable();
			bUnsync.disable();
			bSync.disable();
			bPlay.disable();
			bPlayAll.enable();
			bAddStat.disable();

		} else if (vstate == AnchorDot.STATE_RELATIVE) {
			bAddVideo.enable();
			bDelVideo.disable();
			bUnsync.disable();
			bSync.enable();
			bPlay.enable();
			bPlayAll.enable();
			bAddStat.enable();

		} else if (vstate == AnchorDot.STATE_ANCHOR) {
			bAddVideo.enable();
			bDelVideo.enable();
			bUnsync.enable();
			bSync.enable();
			bPlay.enable();
			bPlayAll.enable();
			bAddStat.enable();
		}
	}

	function f_row_dblclicked() {

		if (state.wr_editor){
			return false;
		}
		f_clicked(bPlay);
	}

	function f_clicked(b) {

		let row = LogTable.get_sel_row();

		if (!row) {
			alert("Go to the state.games to select a team in the dropdown.");
			return;
		}

		let data = row.dataobj;

		if (b == bAddVideo) {
			let fetched_videos;
			let next_page;
			let url;
			let ytid;

			let results = f_yt_initial_list();

			let $modal        = $('#video_select_modal');
			let $cancel_btn   = $('#video_select_modal_cancel');
			let $save_btn     = $('#video_select_modal_save');
			let $ytauth_btn   = $('#video_select_modal_ytauth');
			let $ytdeauth_btn = $('#video_select_modal_ytdeauth');

			$('#yt_list').hide();
			$('#yt_auth').hide();
			$('#yt_deauth').hide();
			$('#yt_no_videos').hide();

			if (!state.yt_auth) {
				$('#yt_auth').show();
			} else if (results.videos && results.videos.length >= 0) {
				next_page = results.next_page;
				$('#yt_deauth').show();
				$('#yt_list_table').empty();
				$('#yt_list_table').append('<tr id="yt-video-count"><td colspan="2" style="font-weight:bold;">Showing most recent ' + results.videos.length + ' of ' + results.total_videos + ' videos</td></tr>');
				f_yt_add_video_rows($('#yt_list_table'), results.videos);
				if (results.total_videos > results.videos.length) {
					let more = '<tr id="yt-get-more"><td colspan="2" style="align:center;">' +
						'<button type="button" id="video_select_modal_more">Get More</button>' +
						'</td></tr>';
					$('#yt_list_table').append(more);
				}
				fetched_videos = results.videos.length;
				$('#yt_list').show();
			} else {
				$('#yt_no_videos').show();
				$('#yt_deauth').show();
			}

			$modal.trigger('openModal');
			$save_btn.attr('disabled', true);

			$ytauth_btn.off('click').click(function(){
				$modal.trigger('closeModal');
				// var base_url = 'http%3A%2F%2Flocalhost%3A8088';
				let base_url = 'https%3A%2F%2Fwww.rotate123.com';
				let redirect_url = 'https://accounts.google.com/o/oauth2/v2/auth?' +
					'scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fyoutube.readonly' +
					'&access_type=offline' +
					'&include_granted_scopes=true' +
					'&prompt=consent' +
					'&state=' + state.solouid +
					'&redirect_uri=' + base_url + '%2Fvidix%2Fyoutube%2Foauth' +
					'&response_type=code' +
					'&client_id=354834625395-er747q22emrdql3adkfdav584n915a4a.apps.googleusercontent.com';
				window.location.href = redirect_url;
			});
			$ytdeauth_btn.off('click').click(function(){
				state.yt_auth = false;
				results = {};
				$('#yt_list').hide();
				$('#yt_deauth').hide();
				$('#yt_auth').show();
				$('#yt_no_videos').hide();

				$.ajax({
					type: "GET",
					url: "/vidix/youtube/deauth",
					async: false,
					fail: function(){
						alert("Unable to remove YouTube authentication. Please try again later or contact Rotate123 support.");
					}
				});
			});

			$('#video_select_modal_youtube_url').off('click').click(function(){
				$('.yt_item').css('background-color', 'rgb(255, 255, 255)');
				$save_btn.attr('disabled', false);
			});
			$('.yt_item').off('click').click(function(){
				$('.yt_item').css('background-color', 'rgb(255, 255, 255)');
				$(this).css('background-color', 'rgb(255, 153, 0)');
				$('#video_select_modal_youtube_url').val('');
				$save_btn.attr('disabled', false);
			});
			$('.yt-preview').off('click').click(function(){
				f_yt_handle_preview($(this));
			});
			$('#video_select_modal_more').off('click').click(function(){
				let more = f_yt_more_list(next_page);
				if (more.videos && more.videos.length >= 0) {
					next_page = more.next_page;
					fetched_videos += more.videos.length;
					$('#yt-video-count').replaceWith('<tr id="yt-video-count"><td colspan="2" style="font-weight:bold;">Showing most recent ' + fetched_videos + ' of ' + results.total_videos + ' videos</td></tr>');
					var get_more = $('#yt-get-more').detach();
					f_yt_add_video_rows($('#yt_list_table'), more.videos);
					$('#yt_list_table').append(get_more);
					$('.yt_item').off('click').click(function(){
						$('.yt_item').css('background-color', 'rgb(255, 255, 255)');
						$(this).css('background-color', 'rgb(255, 153, 0)');
						$('#video_select_modal_youtube_url').val('');
						$save_btn.attr('disabled', false);
					});
					$('.yt-preview').off('click').click(function(){
						f_yt_handle_preview($(this));
					});
				}
				$save_btn.attr('disabled', false);
			});
			$cancel_btn.off('click').click(function(){
				$modal.trigger('closeModal');
			});
			$save_btn.off('click').click(function(){
				ytid = $('.yt_item[style*="background-color: rgb(255, 153, 0)"]').data("id");
				$modal.trigger('closeModal');

				// Get the video url and YouTube id
				url = $('#video_select_modal_youtube_url').val();
				if (url) {
					ytid = f_get_ytid(url);
				}

				// Check the youtube id
				if (!ytid) {
					alert("Sorry but we do not recognize the url you entered as a YouTube url");
					return;
				}

				// Post the new video
				f_attach_video(state.solouid, SelGame, data.logix, ytid, 0, f_attach_video_response);
			});

		} else if ((b == bDelVideo) || (b == bUnsync)) {
			f_detach_video(state.solouid, SelGame, data.logix, f_detach_video_response);

		} else if (b == bSync) {
			// Pause the player
			PlayerMgr.pause_video();

			// Get the parameters
			let uid    = state.solouid;
			let gid    = SelGame;
			let logix  = data.logix;
			let vid    = data.vid;
			let offset = Math.floor(ytplayerState.yt_player.getCurrentTime());

			// Post the sync info (same as attaching but with offset not necessrily at 0)
			f_attach_video(uid, gid, logix, vid, offset, f_attach_video_response);

		} else if (b == bPlay) {

			if ((data.vid !== null) && (data.vstart >= 0) && (data.vend >= 0)) {
				e("novideo").style.visibility = "hidden";
				e("novideo").style.display    = "none";
				PlayerMgr.play_clip(data.vid, data.vstart, data.vend - data.vstart);

			} else {
				e("novideo").style.visibility = "visible";
				e("novideo").style.display    = "block";
				PlayerMgr.pause_video();
			}

		} else if (b == bPlayAll) {

			if (!PLAY_ALL_MONITOR) {
				let firstRow = $('#setup_log_table .data_table_rows').first().children().first()[0];

				$(firstRow).trigger("click");
				data = $(firstRow)[0].dataobj;

				if ((data.vid === null) || (data.vstart < 0) && (data.vend < 0)) {
					let nextRows = $(firstRow).nextAll();
					nextRows.each((index, nextRow) => {
						if ((data.vid === null) || (data.vstart < 0) && (data.vend < 0)) {
							data = $(nextRow)[0].dataobj;
						}
					});
				}

				if ((data.vid !== null) && (data.vstart >= 0) && (data.vend >= 0)) {
					$(".flex_button:contains('Play All')").text('Stop All');
					PlayerMgr.play_clip(data.vid, data.vstart, data.vend - data.vstart);
					PLAY_ALL_MONITOR = window.setInterval(f_play_next, 500);
				}
			} else {
				window.clearInterval(PLAY_ALL_MONITOR);
				PLAY_ALL_MONITOR = null;
				PlayerMgr.stop_clip();
				$(".flex_button:contains('Stop All')").text('Play All');
			}

		} else if (b == bUndoEdits) {

			let undo_edits = confirm("Revert all stat data to its original state?");
			if (undo_edits === true) {
				// Get the parameters
				let uid  = state.solouid,
				    game = e("selGame").value,
				    pkg  = { uid: uid, game: game };

				$.ajax({
					type: "POST",
					url: state.touch ? UNDO_TOUCH_EDITS_URL : UNDO_EDITS_URL,
					async: false,
					data: pkg,
					dataType: 'json',
				})
					.then((rsp) => {
						f_replace_game_data(SelGame, rsp.app_data);
						let vid_data = rsp.vid_data;
						if (typeof vid_data === "string"){
							vid_data = JSON.parse(vid_data);
						}
						state.videos[SelGame] = vid_data;
						f_load_log_table();
					}, () => {
						alert("Unable to undo edits. Please try again later.");
					});
			}

		} else if (b == bAddStat) {

			f_open_stat_modal();
		}
	}

	function f_play_next() {

		var currentRow = LogTable.get_sel_row();
		var currentRowData = $(currentRow)[0].dataobj;

		var nextRows = $(currentRow).nextAll();
		var nextRow = null;
		var nextRowData = null;
		nextRows.each(function (index, row) {
			if (nextRowData === null) {
				var vstate = LogRecs[$(row)[0].dataobj.logix].vstate.state;
				if (vstate == AnchorDot.STATE_ANCHOR || vstate == AnchorDot.STATE_RELATIVE) {
					nextRow = row;
					nextRowData = $(row)[0].dataobj;
				}
			}
		});

		var currentTime = ytplayerState.yt_player.getCurrentTime();

		if (nextRow && nextRowData) {
			if (currentTime >= currentRowData.vend || currentTime >= nextRowData.vstart) {
				$(nextRow).trigger("click");
				if ((nextRowData.vid !== null) && (nextRowData.vstart >= 0) && (nextRowData.vend >= 0)) {
					PlayerMgr.play_clip(nextRowData.vid, nextRowData.vstart, nextRowData.vend - nextRowData.vstart);
				}
			}

		} else {

			window.clearInterval(PLAY_ALL_MONITOR);
			PLAY_ALL_MONITOR = null;
			PlayerMgr.pause_clip();
			$(".flex_button:contains('Stop All')").text('Play All');
		}

	}

	// ---------------------------
	// Callback Methods
	// ---------------------------

	function f_attach_video_response(rsp) {
		var sel_row = $(LogTable.get_sel_row()).index();
		rsp = JSON.parse(rsp);

		// Update the video record
		if (rsp.status == 0) {
			// See if the video and logix already exists
			var vrec = f_get_video_by_logix(parseInt(rsp.logix));

			// Create a new video record if it doesn't already exist
			if (! vrec) {
				vrec       = {};
				vrec.logix = parseInt(rsp.logix);
				state.videos[rsp.gid].push(vrec);
			}

			// Update the video info
			vrec.vid      = rsp.vid;
			vrec.title    = rsp.title;
			vrec.secs     = parseInt(rsp.secs);
			vrec.offset   = parseInt(rsp.offset);

			// Update the sync marks in the log table
			f_mark_synced_recs();

			// TODO: bh - this is a quick hack, clean up.
			if (rsp.begin_trial) {
				alert("Your 7 day trial has been activated.");
				$("#title_bar .subscription_status").text("7 day trial period now active");
			} else {
				alert(rsp.msg);
			}

			f_load_log_table();

			// Reselect the row
			$('.data_table_row:visible')[sel_row].click();
		} else {
			alert(rsp.msg);
		}
	}

	function f_detach_video_response(rsp) {

		var sel_row = $(LogTable.get_sel_row()).index();
		rsp = JSON.parse(rsp);

		// Update the video record
		if (rsp.status == 0) {

			// Get the data
			var gid   = rsp.gid;
			var logix = rsp.logix;

			// Remove the record in the state.videos
			for (var i = state.videos[gid].length-1; i >= 0; i--) {
				if (state.videos[gid][i].logix == logix) {
					state.videos[gid].splice(i, 1);
				}
			}

			// Update the sync marks in the log table
			f_mark_synced_recs();

			f_load_log_table();

			// Reselect the row
			$('.data_table_row:visible')[sel_row].click();

		} else {
			alert(rsp.msg);
		}
	}


	// ---------------------------
	// Message Methods
	// ---------------------------

	function f_show_attached_msg() {
		// Clear the interval
		if (attached_monitor) {
			window.clearInterval(attached_monitor);
			attached_monitor = null;
		}

		// Show the message
		attached_msg.style.visibility = "visible";
		attached_msg.style.display    = "block";

		// Set the interval
		attached_monitor = setInterval(f_hide_attached_msg, 4000);
	}

	function f_hide_attached_msg() {
		attached_msg.style.visibility = "hidden";
		attached_msg.style.display    = "none";
	}

	function f_show_unattached_msg() {
		unattached_msg.style.visibility = "visible";
		unattached_msg.style.display    = "block";
	}

	function f_hide_unattached_msg() {
		unattached_msg.style.visibility = "hidden";
		unattached_msg.style.display    = "none";
	}

	function f_show_synced_msg() {
		// Clear the interval
		if (synced_monitor) {
			window.clearInterval(synced_monitor);
			synced_monitor = null;
		}

		// Show the message
		synced_msg.style.visibility = "visible";
		synced_msg.style.display    = "block";

		// Set the interval
		synced_monitor = setInterval(f_hide_synced_msg, 4000);
	}

	function f_hide_synced_msg() {
		synced_msg.style.visibility = "hidden";
		synced_msg.style.display    = "none";
	}

}
